import React from 'react';

import BannerImage from '../BannerImage';
import useCMSBanner from './useCMSBanner';

interface Props {
    bannerId: string;
}

const CMSBanner: React.FC<Props> = ({ bannerId }) => {
    const { banner } = useCMSBanner({ bannerId });

    if (!banner) return null;

    return <BannerImage banner={banner} />;
};

export default CMSBanner;
